import { isServer } from '@tanstack/react-query'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const QueryKeys = {
  activeCustomer: ['activeCustomer'],
  activeChannel: ['activeChannel'],
}

export function getApiUrl(path: string) {
  if (!isServer) {
    return path
  }

  if (process.env.NEXT_PUBLIC_DOMAIN) {
    return `https://${process.env.NEXT_PUBLIC_DOMAIN}${path}`
  }

  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}${path}`
  }

  return `http://localhost:4200${path}`
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const isDevRuntime = process.env.NODE_ENV === 'development'

/**
 * Converts a string into a URL-friendly slug
 * @param text The string to convert to a slug
 * @returns A lowercase string with spaces and special characters replaced with hyphens
 */
export function slugify(text: string | undefined = undefined): string {
  if (!text) {
    return ''
  }

  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters except hyphens
    .replace(/\-\-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+/, '') // Trim hyphens from start
    .replace(/-+$/, '') // Trim hyphens from end
}

export function hashString(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }
  return hash
}

export { removeColorProperty } from './utils/remove-color-property'
